import { config } from "../utils/config";
export default class Upsell {

    id: string;
    type: string;
    quantity: number;
    unitPrice: number;
    totalPriceWithoutAnyCharges: number;
    totalBasePrice: number;
    totalDiscount: number;
    cancelledLineitemKey: any;
    mainItemId: string;
    categoryName: string;
    mcpSku: string;
    name: string;
    productKey: string;

    constructor(mainItem: any = {}, upsell: any = {}) {
        this.id =  upsell.id ?? '';
        this.type = upsell.custom?.fields?.lineItemType.toLowerCase() ?? '';
        this.quantity =  upsell?.quantity ?? 0;
        this.unitPrice =  upsell?.price?.value?.centAmount ?? 0;
        this.totalBasePrice = mainItem?.data?.effectivePrice?.basePrice?.upsellItem;
        this.totalPriceWithoutAnyCharges = Number(mainItem?.data?.effectivePrice?.originalPrice?.upsellItem ?? mainItem.data.effectivePrice.totalUpsellPrice ?? 0);
        this.totalDiscount = Number(mainItem.data.effectivePrice.discount.upsellItem ?? 0);
        this.cancelledLineitemKey = upsell?.state?.[0]?.state?.obj?.key ?? '';
        this.mainItemId = upsell?.custom?.fields?.lineItemReference ?? '';
        this.categoryName = upsell.custom?.fields?.categoryName;
        this.mcpSku = upsell.custom?.fields?.mcpSku;
        const nameValue = upsell?.name?.[config('locale')];
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.productKey = upsell.custom?.fields?.productKey;
    }
}   
